import * as React from 'react';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
  defintitionsList: {
    display: 'grid',
    gridTemplateColumns: '150px auto',
    rowGap: theme.spacing(1) + 'px',
    alignItems: 'center',
    '& > $term': {
      gridColumn: 1
    },
    '& > $definition': {
      gridColumn: 2
    },
    '& > *': {
      gridColumn: '1/-1'
    }
  },
  term: {
    textAlign: 'right',
    fontWeight: theme.typography.fontWeightBold
  },
  definition: {
    marginLeft: theme.spacing(2)
  }
}));

interface TermProps {
  children?: React.ReactNode
  className?: string
}

export function Term ({ children, className }: TermProps) {
  const classes = useStyles();
  return <dt className={clsx(className, classes.term)}>{children}</dt>;
}

interface DefinitonProps {
  children?: React.ReactNode
  className?: string
}

export function Definiton ({ children, className }: DefinitonProps) {
  const classes = useStyles();
  return <dd className={clsx(className, classes.definition)}>{children}</dd>;
}

interface FilterDisplayProps {
  children?: React.ReactNode
  className?: string
}

export default function DefintionsList ({ className, children }: FilterDisplayProps) {
  const classes = useStyles();

  return (
    <dl className={clsx(className, classes.defintitionsList)}>
      {children}
    </dl>
  );
}
